import APP_CONFIG from '../../app.config';

export class Node implements d3.SimulationNodeDatum {
    // optional - defining optional implementation properties - required for relevant typing assistance
    index?: number;
    x?: number;
    y?: number;
    vx?: number;
    vy?: number;
    fx?: number | null;
    fy?: number | null;

    // Custom properties added below for specific use case
    id: string | number;
    nodeClicked: boolean;
    disabled: boolean;
    label: string;
    data: any; // TODO : need to define better type structure
    // INFO: Added weight but not in use currently value will be undefined.
    weight?: number;
    nodeLevel: number;
    linkCount: number;
    limit: number;
    offset: number;
    collapse: boolean;
    isNextLevel: boolean;
    isArticleNetworkNode: boolean;

    constructor(data: any) {
        this.data = data;
        this.label = data.label;
        this.id = data.id;
        this.nodeClicked = data.nodeClicked;
        this.disabled = data.disabled;
        this.nodeLevel = data.nodeLevel;
        this.linkCount = data.linkCount;
        this.limit = data.limit;
        this.collapse = data.collapse;
        this.offset = data.offset;
        this.isNextLevel = data.isNextLevel;
        this.isArticleNetworkNode = data.isArticleNetworkNode;
    }
    // INFO: Modify below implementation to achieve customization on node radius and color
    normal = () => {
        if (this.nodeLevel === 1) {
            // return 4.8;
            return 3.7;
        }
        if (this.linkCount >= 30) {
            // return 3.6;
            return 3.6;
        }
        if (this.linkCount >= 20) {
            // return 3;
            return 2.5;
        }
        if (this.linkCount >= 10) {
            return 2.4;
        }
        return 1.8;
        //return Math.sqrt(this.linkCount / APP_CONFIG.N);
    };
    // INFO : Modify below logic for radius
    get r() {
        return 10 * this.normal();
        //return 50 * this.normal() + 10;
    }

    get fontSize() {
        return 14 + 'px';
        //return (30 * this.normal() + 10) + 'px';
    }

    // INFO: Modify below code for this requirement: Colour of the node will be defined based on distance from the centre node
    get color() {
        const index = this.nodeLevel - 1;
        //let index = Math.floor(APP_CONFIG.SPECTRUM.length * this.normal());

        if (isNaN(index)) {
            return '#05B2DC26';
        }
        return APP_CONFIG.NODE_FILL_COLOR[index];
    }

    get nodeClass() {
        if (!this.isNextLevel) {
            return 'node node-is-next-level';
        }

        if (this.disabled && !this.collapse) {
            return 'node node-disabled';
        } else if (this.collapse && !this.disabled) {
            return 'node node-clickable ';
        } else if (this.collapse && this.disabled) {
            return 'node node-clickable node-disabled';
        } else {
            return 'node';
        }
    }

    get textClass() {
        if (this.disabled) {
            return 'node-text node-text-disabled';
        } else {
            return 'node-text';
        }
    }
    // TODO: not yet working
    // nodeClicked() {
    //   //console.log("node clicked")
    //   // this.selected = !(this.selected);
    //   // return;
    // }
    // xyz() {
    //   console.log("node clicked with id", this.id);
    //   //alert("yess");
    //   //debugger;
    // }
    // click(d: any) {
    // }
}
